import React from "react";

export default function MarketsNew({ fill }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4676_36809)">
        <path
          d="M9.01481 21.4414V19.5093H6.5V5.43264H9.01481V3.44141H10.7642V5.43264H10.9829C11.6025 5.43264 12.1674 5.45236 12.6777 5.49179V3.44141H14.4271V5.68894C15.5752 5.89924 16.4408 6.26726 17.0239 6.79299C17.6253 7.30559 17.926 8.01534 17.926 8.92224C17.926 9.75028 17.6435 10.4403 17.0786 10.9923C16.5319 11.5312 15.7301 11.8795 14.6731 12.0372V12.1358C15.4021 12.2278 16.049 12.3987 16.6139 12.6484C17.197 12.8981 17.6526 13.253 17.9806 13.713C18.3269 14.1731 18.5 14.7711 18.5 15.5071C18.5 16.5323 18.1355 17.3735 17.4066 18.0307C16.6959 18.6747 15.7027 19.1084 14.4271 19.3319V21.4414H12.6777V19.5093C12.5501 19.5093 12.4134 19.5093 12.2677 19.5093H10.7642V21.4414H9.01481ZM11.4749 11.4261C12.9692 11.4261 13.9898 11.2355 14.5364 10.8543C15.1014 10.46 15.3838 9.88171 15.3838 9.11939C15.3838 8.34393 15.0376 7.7919 14.3451 7.46331C13.6708 7.12158 12.5866 6.95072 11.0923 6.95072H8.96014V11.4261H11.4749ZM8.96014 12.9047V18.011H11.803C13.3155 18.011 14.3724 17.7678 14.9738 17.2815C15.5752 16.7952 15.8759 16.1577 15.8759 15.3691C15.8759 14.6331 15.5661 14.0416 14.9465 13.5947C14.3269 13.1347 13.2153 12.9047 11.6116 12.9047H8.96014Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_4676_36809">
          <rect
            width="24"
            height="24"
            fill={fill}
            transform="translate(0.5 0.441406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
